import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { injectAxnAdminUserId } from "@utils/parameter-injector";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type UpdateAxnAdminUserRequestResponse = {
    transferObject: AxnAdminUser;
};

export const updateAxnAdminUserRequest = async (axnAdminUser: AxnAdminUser): Promise<GenericNetworkResponse<UpdateAxnAdminUserRequestResponse>> => {
    const route = injectAxnAdminUserId(
        apiRoutes.axnadminCore.axnadmin.userWithId,
        axnAdminUser.id
    );

    const body = {
        axnAdminUserDetails: {
            credential: axnAdminUser.axnAdminUserDetails.credential,
            email: axnAdminUser.axnAdminUserDetails.email,
            firstName: axnAdminUser.axnAdminUserDetails.firstName,
            id: axnAdminUser.axnAdminUserDetails.id,
            identityProviderID: axnAdminUser.axnAdminUserDetails.identityProviderID,
            lastName: axnAdminUser.axnAdminUserDetails.lastName,
            apiUserName: axnAdminUser.axnAdminUserDetails.apiUserName,
            apiPassword: axnAdminUser.axnAdminUserDetails.apiPassword
        },
        axnAdminUserOrganizationProperties: axnAdminUser.axnAdminUserOrganizationProperties,
        axnAdminUserProperties: axnAdminUser.axnAdminUserProperties,
        axnAdminUserRPProperties: axnAdminUser.axnAdminUserRPProperties,
        axnAdminUserPreferences: axnAdminUser.axnAdminUserPreferences,
        canCreateRPService: axnAdminUser.canCreateRPService,
        id: axnAdminUser.id,
        mbun: axnAdminUser.mbun,
        organizationID: axnAdminUser.organizationID,
        status: axnAdminUser.status
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};